//libs
import { useCallback, useEffect, useRef } from 'react';

//hooks
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';

//helpers
import { useLoginNudgeContext } from './context';

// base
import { BREAKPOINTS } from 'shared/styles/base';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

export default function Container({ page }: { page: string }) {
  const { isAuthModalVisible, showBottomSheetAuth, showAuthModal, setBottomSheetCallbacks } =
    useAuthModalWrapperContext();
  const { hideNudge } = useLoginNudgeContext();
  const { deviceWidth } = useResponsiveContext();
  const isInitialized = useRef(false);
  
  const isDesktop = deviceWidth > BREAKPOINTS.DESKTOP;

  const trackHideNudge = useCallback(() => {
    hideNudge();
  }, [hideNudge]);

  useEffect(() => {
    const nudgeType = page.includes('plp') ? 'plp-login-nudge' : page.includes('pdp') ? 'pdp-login-nudge' : 'default';
    if (!isAuthModalVisible && !isInitialized.current) {
      isInitialized.current = true;
      
      setBottomSheetCallbacks({
        onSubmit: trackHideNudge,
        onCancel: trackHideNudge,
        onVisible: hideNudge,
      });
      
      if (isDesktop) {
        showAuthModal('', nudgeType);
      } else {
        showBottomSheetAuth('', true, nudgeType);
      }
    }
  }, [isAuthModalVisible, isDesktop, showAuthModal, showBottomSheetAuth]);

  return null;
}
